module.exports = __webpack_public_path__ + "static/img/logo-bg-white.2cb6a584.png";